module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0037.jpg?v=cc46d6fd";